import React, { Component } from "react";
import "./LatestFSInfo.css";
import { NavLink, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { routeCodes } from "../../../config/routes";

class LatestFSInfo extends Component {
  scrollToTop() {
    window.scrollTo(0, 0);
  }

  render() {
    const { data, language } = this.props;
    return (
      <NavLink
        onClick={() => this.scrollToTop()}
        to={{
          pathname: routeCodes.COLLECTION,
          state: { page: 0 },
        }}
      >
        <div className="LatestFSInfo">
          <div className="LatestFSInfo-text">{data.text}</div>
          <div className="LatestFSInfo-content">
            <div className="LatestFSBorder" />
            <h4 className="LatestTitle">{data.title[language]}</h4>
            <span className="LatestSubTitle">{data.subtitle[language]}</span>
            <p className="LatestDesc">{data.description}</p>
            <span className="LatestFSInfo-button">
              {data.ctaLatest[language]}
            </span>
          </div>
          <div
            className="LatestFSInfo-image"
            style={{ backgroundImage: `url(${data.photo})` }}
          />
          <div className="LatestPhoto--Mobile">
            <div
              className="Latest-imageMobile2"
              style={{ backgroundImage: `url(${data.photo3})` }}
            />
          </div>
        </div>
      </NavLink>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
  };
}

export default withRouter(connect(mapStateToProps)(LatestFSInfo));



// WEBPACK FOOTER //
// ./src/components/Home/LatestFSInfo/index.js